/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListClientCallsParams,
  PhoneCallList
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Calls filed against this client, newest first.
 *
 * ORG-SCOPED like the timeline: any member of the owning org may read them. The
 * client is checked against the caller's org FIRST, so an id from another firm
 * reads as not found rather than as an empty list.
 * @summary List Client Calls
 */
export const listClientCalls = (
    clientId: string,
    params?: ListClientCallsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<PhoneCallList>(
      {url: `/clients/${clientId}/calls`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListClientCallsQueryKey = (clientId: string,
    params?: ListClientCallsParams,) => {
    return [
    `/clients/${clientId}/calls`, ...(params ? [params] : [])
    ] as const;
    }


export const getListClientCallsQueryOptions = <TData = Awaited<ReturnType<typeof listClientCalls>>, TError = HTTPValidationError>(clientId: string,
    params?: ListClientCallsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientCalls>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClientCallsQueryKey(clientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClientCalls>>> = ({ signal }) => listClientCalls(clientId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClientCalls>>, TError, TData> & { queryKey: QueryKey }
}

export type ListClientCallsQueryResult = NonNullable<Awaited<ReturnType<typeof listClientCalls>>>
export type ListClientCallsQueryError = HTTPValidationError


/**
 * @summary List Client Calls
 */

export function useListClientCalls<TData = Awaited<ReturnType<typeof listClientCalls>>, TError = HTTPValidationError>(
 clientId: string,
    params?: ListClientCallsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientCalls>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListClientCallsQueryOptions(clientId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






